var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWichtel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 104.13889,
    height: 152.8772,
    viewBox: "0 0 104.13889 152.8772",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "translate(-213.04566,-19.275606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16",
    transform: "translate(74.980411,-8.44374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "matrix(0.99997006,0,0,1.0059913,-27.935952,-3.780455)",
    style: {
      stroke: "#000000",
      strokeWidth: 1.00002,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 237.11608,108.17963 c 10.07291,38.58332 -31.13524,39.13345 -30.35635,72.79979 -4.63307,-9.08387 -13.14714,-18.73436 -20.4924,-28.59936 -12.02056,-16.14415 -20.91085,-32.86281 -4.53844,-48.61279",
    id: "path3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g15",
    style: {
      stroke: "#000000",
      strokeWidth: 1.00002,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 195.51806,94.791307 c -5.84362,1.517727 -8.32617,5.127131 -13.92255,8.987213 -2.71814,0.26455 -5.99899,-0.85306 -6.38858,-4.46944 0.19708,-3.239758 4.8421,-4.817287 5.35222,-6.353005 5.82208,-30.918498 18.32615,-54.37211 78.29626,-51.920301 -1.48991,-4.787724 1.26835,-6.668922 2.74649,-7.582695 2.25917,-0.351744 4.70053,-0.135542 5.49298,1.671775 2.35365,2.621575 0.41646,4.777618 -0.9553,6.328864 -2.17555,1.511314 -3.58984,0.977691 -5.19445,0.776181 -34.91502,21.5025 -38.35128,31.775457 -28.09426,53.544431 8.4164,6.12127 5.86614,12.51404 -0.74984,10.6 -7.54345,-7.564196 -14.67599,-9.261793 -20.90505,-11.478931",
    id: "path1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2",
    cx: 203.51224,
    cy: 91.355507,
    rx: 8.697052,
    ry: 6.3328047
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 176.64096,137.65295 c -1.13653,6.25655 -0.99246,12.37224 -0.0242,16.23846 3.19718,12.76589 6.88528,11.86917 6.88528,11.86917 -3.21832,2.06509 -7.5067,3.4654 -8.68214,7.86522 -0.35315,3.32752 1.38843,5.90692 5.49298,7.6424 l 24.71842,-1.01465 m -5.53767,-10.79302 c -6.18355,-4.79682 -11.55445,-4.86074 -16.01629,-3.6997",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeLinecap: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 234.47084,137.35723 c 2.32608,10.87368 4.1422,21.52667 -0.42231,29.58147 2.7809,1.67717 5.84033,3.49179 6.35871,6.98385 -0.007,3.03153 -0.26241,5.31096 -4.92576,7.10682 l -28.71876,-0.71363 c -0.75391,-5.2607 6.36297,-12.7921 13.77763,-14.00959 4.4911,-0.73744 8.63316,0.21623 13.50819,0.63255",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 237.79859,129.60783 c 4.07928,1.93642 6.97596,6.28238 7.46196,10.91376 -0.37829,5.9147 -3.44556,6.92345 -8.20265,10.45408",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ac0000",
      strokeWidth: 3.98813,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 172.63411,131.04849 c -4.56913,2.16895 -5.52131,10.54389 -3.85808,15.30083 1.27643,3.65067 4.7137,3.87217 7.60507,6.29873",
    id: "path15-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWichtel);
export default __webpack_public_path__ + "static/media/wichtel.aa6de0ff2f6ccc3638db8950faa3817a.svg";
export { ForwardRef as ReactComponent };